var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-table", {
                  ref: "table",
                  attrs: {
                    title: "분류별 목록",
                    tableId: "table",
                    columnSetting: false,
                    isFullScreen: false,
                    usePaging: false,
                    columns: _vm.grid.columns,
                    data: _vm.grid.data,
                    gridHeight: "358px",
                  },
                  on: { rowClick: _vm.rowClick },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8" },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "배관 및 개스킷 상세정보" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _c(
                              "q-btn",
                              {
                                staticClass: "custom-btn",
                                attrs: {
                                  icon: "help",
                                  color: "deep-purple-6",
                                  "text-color": "white",
                                  align: "center",
                                  round: "",
                                },
                              },
                              [
                                _c(
                                  "q-tooltip",
                                  {
                                    attrs: {
                                      anchor: "bottom left",
                                      self: "top left",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustomTop" },
                                      [_vm._v(" (주) ")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustom" },
                                      [
                                        _vm._v(
                                          " ① 분류코드란에는 공정배관계장도 도면상의 배관분류 코드를 기재합니다."
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " ② 배관재질란은 KS/ASTM 등의 기호로 기재합니다."
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " ③ 개스킷 재질 및 형태란에는 일반명 및 형태를 기입하고 상품번호는 기재하지 아니합니다. "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.psiPipeGasketId &&
                                    !_vm.isRevision,
                                  expression:
                                    "editable && popupParam.psiPipeGasketId && !isRevision",
                                },
                              ],
                              attrs: { label: "개정", icon: "restart_alt" },
                              on: { btnClicked: _vm.SetRevision },
                            }),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.psiPipeGasketId &&
                                    _vm.isRevision,
                                  expression:
                                    "editable && popupParam.psiPipeGasketId && isRevision",
                                },
                              ],
                              attrs: { label: "개정취소", icon: "restart_alt" },
                              on: { btnClicked: _vm.CancelRevision },
                            }),
                            _vm.editable && _vm.popupParam.psiPipeGasketId
                              ? _c("c-btn", {
                                  attrs: { label: "신규", icon: "add" },
                                  on: { btnClicked: _vm.addData },
                                })
                              : _vm._e(),
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.data,
                                    mappingType: _vm.mappingType,
                                    label: "저장",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveData,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                            _vm.editable &&
                            _vm.popupParam.psiPipeGasketId &&
                            _vm.deletable
                              ? _c("c-btn", {
                                  attrs: { label: "삭제", icon: "remove" },
                                  on: { btnClicked: _vm.deleteData },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "분류코드",
                              name: "pipeTypeCd",
                            },
                            model: {
                              value: _vm.data.pipeTypeCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "pipeTypeCd", $$v)
                              },
                              expression: "data.pipeTypeCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "유체의명칭 또는 구분",
                              name: "pipeName",
                            },
                            model: {
                              value: _vm.data.pipeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "pipeName", $$v)
                              },
                              expression: "data.pipeName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              suffix: "MPa",
                              editable: _vm.editable,
                              label: "설계압력(MPa)",
                              name: "designPress",
                            },
                            model: {
                              value: _vm.data.designPress,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "designPress", $$v)
                              },
                              expression: "data.designPress",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              suffix: "℃",
                              editable: _vm.editable,
                              label: "설계온도(℃)",
                              name: "designTemp",
                            },
                            model: {
                              value: _vm.data.designTemp,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "designTemp", $$v)
                              },
                              expression: "data.designTemp",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "배관재질",
                              name: "pipeMaterial",
                            },
                            model: {
                              value: _vm.data.pipeMaterial,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "pipeMaterial", $$v)
                              },
                              expression: "data.pipeMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "개스킷 재질 및 형태",
                              name: "gasketMaterial",
                            },
                            model: {
                              value: _vm.data.gasketMaterial,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "gasketMaterial", $$v)
                              },
                              expression: "data.gasketMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "개스킷 재질 및 형태",
                              name: "gasketMaterial",
                            },
                            model: {
                              value: _vm.data.gasketMaterial,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "gasketMaterial", $$v)
                              },
                              expression: "data.gasketMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              suffix: "%",
                              editable: _vm.editable,
                              label: "비파괴검사율(%)",
                              name: "noneDestructPercent",
                            },
                            model: {
                              value: _vm.data.noneDestructPercent,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "noneDestructPercent", $$v)
                              },
                              expression: "data.noneDestructPercent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "후열처리여부",
                              name: "afterHeatTreatFlag",
                            },
                            model: {
                              value: _vm.data.afterHeatTreatFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "afterHeatTreatFlag", $$v)
                              },
                              expression: "data.afterHeatTreatFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-process", {
                            attrs: {
                              editable: _vm.editable,
                              label: "관련공정",
                              multiple: "single",
                              name: "processCd",
                            },
                            model: {
                              value: _vm.data.processCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "processCd", $$v)
                              },
                              expression: "data.processCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-dept", {
                            attrs: {
                              editable: _vm.editable,
                              label: "관리부서",
                              name: "deptCd",
                            },
                            model: {
                              value: _vm.data.deptCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deptCd", $$v)
                              },
                              expression: "data.deptCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-textarea", {
                            attrs: {
                              editable: _vm.editable,
                              label: "비고",
                              name: "remarks",
                              rows: 3,
                            },
                            model: {
                              value: _vm.data.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "remarks", $$v)
                              },
                              expression: "data.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-table",
                  {
                    ref: "substanceTable",
                    attrs: {
                      title: "배관 및 개스킷 별 화학물질 목록",
                      tableId: "substanceTable",
                      columns: _vm.grid2.columns,
                      data: _vm.grid2.data,
                      columnSetting: false,
                      selection: "multiple",
                      rowKey: "psiPipeGasketSubstancesId",
                      filtering: false,
                      usePaging: false,
                      hideBottom: true,
                      gridHeight: "250px",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "table-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: {
                                    label: "환경부-화학물질정보 연동 추가",
                                    icon: "add",
                                  },
                                  on: { btnClicked: _vm.addApiRow },
                                })
                              : _vm._e(),
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: { label: "추가", icon: "add" },
                                  on: { btnClicked: _vm.addrow },
                                })
                              : _vm._e(),
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: { label: "삭제", icon: "remove" },
                                  on: { btnClicked: _vm.removeRow },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _vm.popupParam.psiPipeGasketId
                  ? _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm",
                        attrs: { title: "개정", topClass: "topcolor-orange" },
                      },
                      [
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                                  },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "개정번호",
                                        name: "revisionNum",
                                      },
                                      model: {
                                        value: _vm.data.revisionNum,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "revisionNum", $$v)
                                        },
                                        expression: "data.revisionNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                                  },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "개정일시",
                                        name: "regDtStr",
                                      },
                                      model: {
                                        value: _vm.data.regDtStr,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regDtStr", $$v)
                                        },
                                        expression: "data.regDtStr",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                                  },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "개정자",
                                        name: "regUserName",
                                      },
                                      model: {
                                        value: _vm.data.regUserName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regUserName", $$v)
                                        },
                                        expression: "data.regUserName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                                  },
                                  [
                                    _c("c-moc", {
                                      attrs: {
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        isSubmit: _vm.saveCallData,
                                        document: _vm.data,
                                        documentId:
                                          _vm.popupParam.psiPipeGasketId,
                                        documentTitle: "pipeName",
                                        mocRelatedTaskCd: "RT00000001",
                                        label: "MOC번호",
                                        name: "sopMocId",
                                      },
                                      on: {
                                        "update:document": function ($event) {
                                          _vm.data = $event
                                        },
                                      },
                                      model: {
                                        value: _vm.data.sopMocId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "sopMocId", $$v)
                                        },
                                        expression: "data.sopMocId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "개정사유",
                                        name: "revisionContent",
                                      },
                                      model: {
                                        value: _vm.data.revisionContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "revisionContent",
                                            $$v
                                          )
                                        },
                                        expression: "data.revisionContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                              staticStyle: { "margin-top": "-18px !important" },
                              attrs: { id: "revdiv" },
                            },
                            [
                              _c("c-table", {
                                ref: "revision",
                                attrs: {
                                  title: "개정이력",
                                  tableId: "revision",
                                  topBorderClass: "topcolor-orange",
                                  columns: _vm.gridrev.columns,
                                  data: _vm.gridrev.data,
                                  gridHeight: "150px",
                                  columnSetting: false,
                                  expandAll: false,
                                  isFullScreen: false,
                                  usePaging: false,
                                  hideBottom: true,
                                  filtering: false,
                                },
                                on: { rowClick: _vm.rowClickRev },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }